import * as React from 'react';
import clsx from 'clsx';
import { Typography } from '@/components/common';

export interface DocumentSubmittedSuccessMessageProps {
	documentName?: string;
	className?: string;
}

export const DocumentSubmittedSuccessMessage: React.FC<
	DocumentSubmittedSuccessMessageProps
> = ({ documentName, className }) => {
	return (
		<Typography
			type="regular-14"
			className={clsx(
				'w-full max-w-full min-w-0 break-words text-center text-opacity-black',
				className
			)}
		>
			{documentName ? (
				<>
					Your <span className="font-semibold break-all">{documentName}</span>{' '}
					has been signed and submitted successfully.
				</>
			) : (
				'The document has been signed and submitted successfully.'
			)}
		</Typography>
	);
};
